// src/utils.ts
function createGetterProxy(propHandler) {
  return new Proxy(
    {},
    {
      get(_target, prop, _receiver) {
        return propHandler(prop);
      }
    }
  );
}

// src/record.ts
function createFnRecordQueryProxy(fnRecord) {
  return createGetterProxy(
    (k) => createGetterProxy((prop) => {
      if (prop === "queryKey" || prop === "mutationKey") {
        return [k];
      }
      if (prop === "queryOptions") {
        return (input) => ({
          queryKey: [k, input],
          // TODO: maybe strip if `input = undefined`?
          queryFn: async () => fnRecord[k](input)
        });
      }
      if (prop === "infiniteQueryOptions") {
        return (inputFn) => ({
          queryKey: [k, inputFn()],
          queryFn: (context) => fnRecord[k](inputFn(context))
        });
      }
      if (prop === "mutationOptions") {
        return () => ({
          mutationKey: [k],
          mutationFn: async (input) => fnRecord[k](input)
        });
      }
      throw new Error("invalid proxy usage", { cause: { k, prop } });
    })
  );
}

// src/trpc.ts
function createTrpcClientQueryProxy(client) {
  return createGetterProxy(
    (k) => createGetterProxy((prop) => {
      if (prop === "queryOptions") {
        return (input) => ({
          queryKey: [k, input],
          queryFn: () => client[k].query(input)
        });
      }
      if (prop === "infiniteQueryOptions") {
        return (input, options) => ({
          queryKey: [k, input],
          queryFn: ({ pageParam }) => client[k].query(options.setPageParam(input, pageParam)),
          getNextPageParam: options.getNextPageParam
        });
      }
      if (prop === "mutationOptions") {
        return () => ({
          mutationKey: [k],
          mutationFn: (input) => client[k].mutate(input)
        });
      }
      throw new Error("invalid proxy usage", { cause: { k, prop } });
    })
  );
}
export {
  createFnRecordQueryProxy,
  createTrpcClientQueryProxy
};
